export default "/assets/images/uk-union-jack-sm.webp?aea8c8a470d9333ed223b70b89a6fe3f";